// extracted by mini-css-extract-plugin
module.exports = {"infoHeader":"BasicInfoSection_infoHeader__1KGo-","infoSection":"BasicInfoSection_infoSection__Y8E3-","infoItem":"BasicInfoSection_infoItem__Nvtqs"};